import { render, staticRenderFns } from "./SubmitThird.vue?vue&type=template&id=65c50120&scoped=true"
import script from "./SubmitThird.vue?vue&type=script&lang=js"
export * from "./SubmitThird.vue?vue&type=script&lang=js"
import style0 from "./SubmitThird.vue?vue&type=style&index=0&id=65c50120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c50120",
  null
  
)

export default component.exports